import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiAlertTriangle, FiRefreshCw } from 'react-icons/fi';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6 text-slate-800">
          <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg border border-red-200 overflow-hidden">
            <div className="bg-red-50 border-b border-red-100 p-4 flex items-center gap-3">
              <SafeIcon icon={FiAlertTriangle} className="text-red-500 text-xl" />
              <h2 className="text-lg font-semibold text-red-700">Application Error</h2>
            </div>
            <div className="p-6">
              <p className="mb-4 text-sm text-slate-600">
                The application encountered an unexpected error. Please review the details below.
              </p>
              <div className="bg-slate-900 rounded p-4 overflow-auto max-h-64">
                <p className="text-red-400 font-mono text-sm font-bold mb-2">
                  {this.state.error?.toString()}
                </p>
                <pre className="text-slate-300 font-mono text-xs whitespace-pre-wrap">
                  {this.state.errorInfo?.componentStack}
                </pre>
              </div>
              <div className="mt-6 flex justify-end">
                <button
                  onClick={() => window.location.reload()}
                  className="flex items-center gap-2 px-4 py-2 bg-slate-800 text-white rounded hover:bg-slate-700 transition-colors text-sm font-medium"
                >
                  <SafeIcon icon={FiRefreshCw} />
                  Reload Application
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;